import { Modal } from '~/4trend/Modal';
import { LogisticForm } from './LogisticForm';

export const LogisticModal = {
	name: 'LogisticModal',
	data: () => ({
		item: {},
		deliveryServices: [],
		cargoTypes: [],
	}),
	mounted() {
		this.$refs.modal.$el.querySelector('.modal-dialog').classList.add('modal-dialog-centered');
	},
	beforeDestroy() {
		this.$el.parentElement.removeChild(this.$el);
	},
	render() {
		return (
			<Modal ref="modal" title="Добавить перемещение" onHidden={ () => this.$destroy() }>
				<LogisticForm
					item={ this.item }
					deliveryServices={ this.deliveryServices }
					cargoTypes={ this.cargoTypes }
				/>
			</Modal>
		);
	},
}
